import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setOptionEdit } from "../../reducer/tourEditReducer";
import { Paths } from "../../router/Paths";
import RoleBasedComponent from "../../components/RoleBasedComponent";

export default function ManageScheduleSection({ optionData }: any) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleEdit = () => {
    dispatch(setOptionEdit(optionData._id));
    navigate(Paths.tourManagementPackageOptionsAvailabilitySchedule, {
      state: { optionData },
    });
  };
  return (
    <section className="bg-white p-2 sm:p-6">
      <div className="flex justify-between items-center">
        <p className="text-xl font-bold">Schedule</p>
        <RoleBasedComponent allowedRoles={["supplier"]}>
          <button
            onClick={handleEdit}
            className="text-sm text-primary underline font-bold"
          >
            Edit
          </button>
        </RoleBasedComponent>
      </div>
      {/* content */}
      <div className="flex flex-col sm:items-end gap-6">
        <div className="w-full max-w-[836px] flex flex-col sm:flex-row gap-6">
          <div className="w-full text-sm">
            <div className="space-y-2">
              <p className="font-bold">Schedule Name</p>
              <p className="text-secondary capitalize">
                {optionData?.scheduleSettings?.name}
              </p>
            </div>
          </div>
          <div className="w-full text-sm">
            <div className="space-y-2">
              <p className="font-bold">Schedule Starting Date</p>
              <p className="text-secondary capitalize">
                {optionData?.scheduleSettings?.startingDate
                  ? new Date(
                      optionData.scheduleSettings.startingDate
                    ).toLocaleDateString("en-US")
                  : "N/A"}
              </p>
            </div>
          </div>
        </div>
        <div className="w-full max-w-[836px] flex flex-col sm:flex-row gap-6">
          <div className="w-full text-sm">
            <div className="space-y-2">
              <p className="font-bold">Does it have End Date</p>
              <p className="text-secondary capitalize">
                {optionData?.scheduleSettings?.hasEndDate ? "Yes" : "No"}
              </p>
            </div>
          </div>
          {optionData?.scheduleSettings?.hasEndDate && (
            <div className="w-full text-sm">
              <div className="space-y-2">
                <p className="font-bold">Schedule End Date</p>
                <p className="text-secondary capitalize">
                  {optionData?.scheduleSettings?.endDate
                    ? new Date(
                        optionData.scheduleSettings.endDate
                      ).toLocaleDateString("en-US")
                    : "N/A"}
                </p>
              </div>
            </div>
          )}
        </div>
        <div className="w-full max-w-[836px] flex flex-col sm:flex-row gap-6">
          <div className="w-full">
            <div className="space-y-2">
              <p className="text-sm font-bold">Weekly Schedule</p>
              <div className="text-secondary capitalize">
                {(() => {
                  const ws = optionData?.scheduleSettings?.weeklySchedule;
                  const dayNames = [
                    "Monday",
                    "Tuesday",
                    "Wednesday",
                    "Thursday",
                    "Friday",
                    "Saturday",
                    "Sunday",
                  ];
                  if (!ws) return "N/A";
                  if (Array.isArray(ws)) {
                    const valid = ws.filter(
                      (item: any) =>
                        item &&
                        typeof item === "object" &&
                        Object.keys(item).length > 0
                    );
                    if (valid.length === 0) return "N/A";
                    return valid.map((item: any, idx: number) => (
                      <div
                        key={item.day || item.value || idx}
                        className="flex gap-2 mb-2"
                      >
                        <span>
                          {item.day ||
                            item.value ||
                            dayNames[idx] ||
                            `Day ${idx + 1}`}
                          :
                        </span>
                        <span>
                          {item.time
                            ? item.time
                            : item.start && item.end
                            ? `${item.start} - ${item.end}`
                            : "N/A"}
                        </span>
                      </div>
                    ));
                  }
                  if (typeof ws === "object" && Object.keys(ws).length > 0) {
                    return Object.entries(ws).map(
                      ([day, time]: [string, any]) => (
                        <div key={day} className="flex gap-2 mb-2">
                          <span>{day}:</span>
                          <span>{time || "N/A"}</span>
                        </div>
                      )
                    );
                  }
                  return "N/A";
                })()}
              </div>
            </div>
          </div>
          <div className="w-full">
            <div className="space-y-2">
              <p className="text-sm font-bold">Exceptions</p>
              <div className="w-full flex flex-col gap-6">
                {Array.isArray(optionData?.scheduleSettings?.exceptions) &&
                optionData?.scheduleSettings?.exceptions?.length > 0 ? (
                  optionData?.scheduleSettings?.exceptions.map(
                    (exception: any, index: number) => (
                      <div key={index} className="w-full">
                        <div className="space-y-2">
                          <p className="text-secondary capitalize">
                            <span>Date:</span>{" "}
                            {exception.date || `Exception ${index + 1}`}
                          </p>
                          <p className="text-secondary capitalize">
                            <span>Time:</span>{" "}
                            {exception.time ||
                              `${exception.start} - ${exception.end}`}
                          </p>
                        </div>
                      </div>
                    )
                  )
                ) : (
                  <p className="text-secondary capitalize">N/A</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
